/**
 * Sets innerHTMLL while also executing any <script> tags in the HTML
 */
export const setInnerHTML = (elm: HTMLElement, html: string, ignoreScripts?: RegExp[]) => {
  // eslint-disable-next-line functional/immutable-data
  elm.innerHTML = html;
  const document = elm.ownerDocument;
  Array.from(elm.querySelectorAll('script')).forEach(oldScript => {
    if (ignoreScripts && oldScript.src && ignoreScripts.some(re => re.test(oldScript.src))) {
      return;
    }
    const newScript = document.createElement('script');
    Array.from(oldScript.attributes).forEach(attr => newScript.setAttribute(attr.name, attr.value));
    newScript.appendChild(document.createTextNode(oldScript.innerHTML));
    oldScript.parentNode?.replaceChild(newScript, oldScript);
  });
};
